// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { FormAssociated, FoundationElement } from '@microsoft/fast-foundation';
class _DateField extends FoundationElement {
}
/**
 * A form-associated base class for the {@link @jupyter/web-components#(DateField:class)} component.
 *
 * @internal
 */
export class FormAssociatedDateField extends FormAssociated(_DateField) {
    constructor() {
        super(...arguments);
        this.proxy = document.createElement('input');
    }
}
